/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A block
 * @export
 * @interface Block
 */
export interface Block {
    /**
     * Set to `true` if block corresponds to the canonical chain tip
     * @type {boolean}
     * @memberof Block
     */
    canonical: boolean;
    /**
     * Height of the block
     * @type {number}
     * @memberof Block
     */
    height: number;
    /**
     * Hash representing the block
     * @type {string}
     * @memberof Block
     */
    hash: string;
    /**
     * Unix timestamp (in seconds) indicating when this block was mined.
     * @type {number}
     * @memberof Block
     */
    block_time: number;
    /**
     * An ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ) indicating when this block was mined.
     * @type {string}
     * @memberof Block
     */
    block_time_iso: string;
    /**
     * The only hash that can uniquely identify an anchored block or an unconfirmed state trie
     * @type {string}
     * @memberof Block
     */
    index_block_hash: string;
    /**
     * Hash of the parent block
     * @type {string}
     * @memberof Block
     */
    parent_block_hash: string;
    /**
     * Unix timestamp (in seconds) indicating when this block was mined.
     * @type {number}
     * @memberof Block
     */
    burn_block_time: number;
    /**
     * An ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ) indicating when this block was mined.
     * @type {string}
     * @memberof Block
     */
    burn_block_time_iso: string;
    /**
     * Hash of the anchor chain block
     * @type {string}
     * @memberof Block
     */
    burn_block_hash: string;
    /**
     * Height of the anchor chain block
     * @type {number}
     * @memberof Block
     */
    burn_block_height: number;
    /**
     * Anchor chain transaction ID
     * @type {string}
     * @memberof Block
     */
    miner_txid: string;
    /**
     * The hash of the last streamed block that precedes this block to which this block is to be appended. Not every anchored block will have a parent microblock stream. An anchored block that does not have a parent microblock stream has the parent microblock hash set to an empty string, and the parent microblock sequence number set to -1.
     * @type {string}
     * @memberof Block
     */
    parent_microblock_hash: string;
    /**
     * The hash of the last streamed block that precedes this block to which this block is to be appended. Not every anchored block will have a parent microblock stream. An anchored block that does not have a parent microblock stream has the parent microblock hash set to an empty string, and the parent microblock sequence number set to -1.
     * @type {number}
     * @memberof Block
     */
    parent_microblock_sequence: number;
    /**
     * List of transactions included in the block
     * @type {Array<string>}
     * @memberof Block
     */
    txs: Array<string>;
    /**
     * List of microblocks that were accepted in this anchor block. Not every anchored block will have a accepted all (or any) of the previously streamed microblocks. Microblocks that were orphaned are not included in this list.
     * @type {Array<string>}
     * @memberof Block
     */
    microblocks_accepted: Array<string>;
    /**
     * List of microblocks that were streamed/produced by this anchor block's miner. This list only includes microblocks that were accepted in the following anchor block. Microblocks that were orphaned are not included in this list.
     * @type {Array<string>}
     * @memberof Block
     */
    microblocks_streamed: Array<string>;
    /**
     * Execution cost read count.
     * @type {number}
     * @memberof Block
     */
    execution_cost_read_count: number;
    /**
     * Execution cost read length.
     * @type {number}
     * @memberof Block
     */
    execution_cost_read_length: number;
    /**
     * Execution cost runtime.
     * @type {number}
     * @memberof Block
     */
    execution_cost_runtime: number;
    /**
     * Execution cost write count.
     * @type {number}
     * @memberof Block
     */
    execution_cost_write_count: number;
    /**
     * Execution cost write length.
     * @type {number}
     * @memberof Block
     */
    execution_cost_write_length: number;
    /**
     * List of txs counts in each accepted microblock
     * @type {{ [key: string]: number; }}
     * @memberof Block
     */
    microblock_tx_count: { [key: string]: number; };
}

export function BlockFromJSON(json: any): Block {
    return BlockFromJSONTyped(json, false);
}

export function BlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): Block {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'canonical': json['canonical'],
        'height': json['height'],
        'hash': json['hash'],
        'block_time': json['block_time'],
        'block_time_iso': json['block_time_iso'],
        'index_block_hash': json['index_block_hash'],
        'parent_block_hash': json['parent_block_hash'],
        'burn_block_time': json['burn_block_time'],
        'burn_block_time_iso': json['burn_block_time_iso'],
        'burn_block_hash': json['burn_block_hash'],
        'burn_block_height': json['burn_block_height'],
        'miner_txid': json['miner_txid'],
        'parent_microblock_hash': json['parent_microblock_hash'],
        'parent_microblock_sequence': json['parent_microblock_sequence'],
        'txs': json['txs'],
        'microblocks_accepted': json['microblocks_accepted'],
        'microblocks_streamed': json['microblocks_streamed'],
        'execution_cost_read_count': json['execution_cost_read_count'],
        'execution_cost_read_length': json['execution_cost_read_length'],
        'execution_cost_runtime': json['execution_cost_runtime'],
        'execution_cost_write_count': json['execution_cost_write_count'],
        'execution_cost_write_length': json['execution_cost_write_length'],
        'microblock_tx_count': json['microblock_tx_count'],
    };
}

export function BlockToJSON(value?: Block | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'canonical': value.canonical,
        'height': value.height,
        'hash': value.hash,
        'block_time': value.block_time,
        'block_time_iso': value.block_time_iso,
        'index_block_hash': value.index_block_hash,
        'parent_block_hash': value.parent_block_hash,
        'burn_block_time': value.burn_block_time,
        'burn_block_time_iso': value.burn_block_time_iso,
        'burn_block_hash': value.burn_block_hash,
        'burn_block_height': value.burn_block_height,
        'miner_txid': value.miner_txid,
        'parent_microblock_hash': value.parent_microblock_hash,
        'parent_microblock_sequence': value.parent_microblock_sequence,
        'txs': value.txs,
        'microblocks_accepted': value.microblocks_accepted,
        'microblocks_streamed': value.microblocks_streamed,
        'execution_cost_read_count': value.execution_cost_read_count,
        'execution_cost_read_length': value.execution_cost_read_length,
        'execution_cost_runtime': value.execution_cost_runtime,
        'execution_cost_write_count': value.execution_cost_write_count,
        'execution_cost_write_length': value.execution_cost_write_length,
        'microblock_tx_count': value.microblock_tx_count,
    };
}

